import React from 'react';
import { useTranslation } from '../redux/TranslationHelper';
import './ImageTextComponent.css';

// 컴포넌트를 가장 기본적인 형태로 단순화
function ImageTextComponent(props) {
  const { t } = useTranslation();
  const { 
    id, 
    style = {}, 
    componentProps = {}, 
    content = '', 
    viewMode = 'pc' 
  } = props;

  // 기본 속성 추출
  const imageUrl = componentProps.imageUrl || 'https://via.placeholder.com/400x300';
  const imagePosition = componentProps.imagePosition || 'left';
  const imageWidth = componentProps.imageWidth || '50%';
  const textWidth = componentProps.textWidth || '50%';
  const gap = componentProps.gap || '0%';
  const verticalAlign = componentProps.verticalAlign || 'middle';
  
  // 두 번째 이미지 옵션 (텍스트 대신 이미지 표시)
  const useSecondImage = componentProps.useSecondImage || false;
  const secondImageUrl = componentProps.secondImageUrl || 'https://via.placeholder.com/400x300';
  
  // 텍스트 내용 (HTML 허용)
  let textContent = t('샘플 텍스트입니다. 내용을 수정해주세요.');
  
  // content가 객체인 경우 (디바이스별 설정이 있는 경우)
  if (typeof content === 'object' && content !== null) {
    if (content.deviceProperty && content.deviceProperty[viewMode]) {
      // 현재 디바이스에 맞는 내용 사용
      textContent = content.deviceProperty[viewMode];
    } else if (content.html) {
      // 기본 HTML 내용 사용
      textContent = content.html;
    }
  } else if (typeof content === 'string') {
    // 단순 문자열 내용
    textContent = content;
  }
  
  // 모바일 환경 확인
  const isMobile = viewMode === 'mobile' || viewMode === 'tablet';
  
  // 수직 정렬에 따른 스타일 설정
  const secondContainerStyle = {
    width: isMobile ? '100%' : textWidth,
    order: imagePosition === 'left' ? 1 : 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: verticalAlign === 'top' ? 'flex-start' : 
                   verticalAlign === 'bottom' ? 'flex-end' : 'center',
    height: 'auto'
  };
  
  return (
    <div id={id} className="image-text-component" style={{
      ...style,
      justifyContent: 'space-between',
      gap: isMobile ? '20px' : gap,
      height: 'auto',
      minHeight: 'unset'
    }}>
      <div className="image-container" style={{ 
        width: isMobile ? '100%' : imageWidth,
        order: imagePosition === 'left' ? 0 : 1,
        height: 'auto'
      }}>
        <img src={imageUrl} alt={t('이미지')} style={{ width: '100%', borderRadius: '0' }} />
      </div>
      
      {useSecondImage ? (
        // 두 번째 이미지 컨테이너
        <div className="image-container second-image" style={secondContainerStyle}>
          <img src={secondImageUrl} alt={t('두 번째 이미지')} style={{ width: '100%', borderRadius: '0' }} />
        </div>
      ) : (
        // 기존 텍스트 컨테이너
        <div className="text-container" style={secondContainerStyle}>
          <div className="text-content" dangerouslySetInnerHTML={{ __html: textContent }}></div>
        </div>
      )}
    </div>
  );
}

export default ImageTextComponent;